export const AllStarConstants = {
  AL: 159,
  NL: 160
};
